export interface CartFavoritesTracking {
  name?: string;
  rule?: string;
  currency: string;
}

const DEFAULT_TRACKING_NAME = 'wishlist_items';
const DEFAULT_TRACKING_RULE = 'last_wishlist_adds';
const DEFAULT_CURRENCY = 'EUR';

export const defaultTracking = (): CartFavoritesTracking => ({
  name: DEFAULT_TRACKING_NAME,
  rule: DEFAULT_TRACKING_RULE,
  currency: DEFAULT_CURRENCY,
});

export const trackingWithDefaults = (tracking?: Partial<CartFavoritesTracking>): CartFavoritesTracking => ({
  name: tracking?.name ?? DEFAULT_TRACKING_NAME,
  rule: tracking?.rule ?? DEFAULT_TRACKING_RULE,
  currency: tracking?.currency ?? DEFAULT_CURRENCY,
});
